import React, {useEffect} from 'react';
import {Button, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import API from '../services/API';
import Utils from '../services/Utils';

export default (props) => {
  const {history, intl, show, onClose} = props;
  const [showGoogleModal, setShowGoogleModal] = React.useState(false);
  const [isGoogleConnected, setIsGoogleConnected] = React.useState(false);

  useEffect(() => {
    setShowGoogleModal(show);
    if (show && !isGoogleConnected) {
      API.getCheckGoogleCalendar(history).then(response => {
        if (response && response.data.success === true && response.data.data === true) {
          setIsGoogleConnected(true);
        }
      });
    }
  }, [show]);

  const googleConnect = () => {
    API.getGoogleCalendarUrl(history).then(response => {
      if (response && response.data.success === true) {
        window.open(response.data.data, '_blank');
        handleClose();
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const googleDisconnect = () => {
    API.deleteGoogleCalendar(history).then(response => {
      if (response && response.data.success === true) {
        setIsGoogleConnected(false);
        Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SAVED_CHANGES'}));
        handleClose();
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShowGoogleModal(false);
  };

  return (
    <>
      <Modal as={Modal.Dialog} centered show={showGoogleModal} onHide={() => handleClose()}>
        <Modal.Header>
          <Modal.Title className="h6"><FormattedMessage id="GOOGLE_CALENDAR_SYNC"/></Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => handleClose()}/>
        </Modal.Header>
        <Modal.Body>
          {isGoogleConnected &&
            <>
              <b><FormattedMessage id="GOOGLE_CALENDAR_ALREADY_CONNECTED"/></b>
              <br/><br/>
              <FormattedMessage id="GOOGLE_CALENDAR_ALREADY_CONNECTED_INFO"/>
            </>
          }
          {!isGoogleConnected &&
            <>
              <FormattedMessage id="GOOGLE_CALENDAR_INFO"/>
              <br/><br/>
              <ul>
                <li><FormattedMessage id="GOOGLE_CALENDAR_INFO_LIST_1"/></li>
                <li><FormattedMessage id="GOOGLE_CALENDAR_INFO_LIST_2"/></li>
                <li><FormattedMessage id="GOOGLE_CALENDAR_INFO_LIST_3"/></li>
              </ul>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          {isGoogleConnected &&
          <Button variant="danger" className="m-1" onClick={() => googleDisconnect()}>
            <FormattedMessage id="DISCONNECT_GOOGLE_CALENDAR"/>
          </Button>
          }
          {!isGoogleConnected &&
            <Button variant="tertiary" className="m-1" onClick={() => googleConnect()}>
              <FormattedMessage id="GOOGLE_CONNECT"/>
            </Button>
          }
          <Button variant="link" className="text-gray ms-auto" onClick={() => handleClose()}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}